import script from "./dataNav.vue?vue&type=script&setup=true&lang=js"
export * from "./dataNav.vue?vue&type=script&setup=true&lang=js"

import "./dataNav.vue?vue&type=style&index=0&id=1f0aabfe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f0aabfe"]])

export default __exports__